/**
 * portal 透传全局配置
 */
import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import getRandomId from '@/utils/uuid';

let portalInst: {
  renderPortalNode: (Comp) => string;
  removePortalNode: (nodeId) => void;
};

interface IPortalNode {
  nodeId: string;
  node: React.ReactNode;
  container: HTMLElement;
}

const Index = () => {
  const [portalNode, setNodeList] = useState<Array<IPortalNode>>([]);

  useEffect(() => {
    portalInst = {
      renderPortalNode: (Comp) => {
        const nodeId = getRandomId();
        const container = document.createElement('div');
        document.body.appendChild(container);
        setNodeList((nodes) => {
          return nodes.concat({
            node: ReactDOM.createPortal(<Comp />, container, nodeId),
            nodeId,
            container,
          });
        });
        return nodeId;
      },
      removePortalNode: (nodeId) => {
        setNodeList((nodes) => {
          return nodes.filter((item) => {
            if (item.nodeId === nodeId) {
              if (item.container) {
                item.container.remove();
              }
              return false;
            }
            return true;
          });
        });
      },
    };
  }, []);

  const renderNodeList = useMemo(() => {
    return portalNode.map((item) => item.node);
  }, [portalNode]);

  return <>{renderNodeList}</>;
};

export const getPortal = () => {
  if (!portalInst) {
    throw new Error('节点未挂载');
  }
  return portalInst;
};

export default Index;
